import { Flex, Heading, Text, VStack } from '@chakra-ui/react'

const PageHeader = ({ title, description, actions }) => (
  <Flex
    align="center"
    justify="space-between"
    wrap="wrap"
    gap={4}
    mb={6}
  >
    <VStack align="flex-start" gap={1}>
      <Heading size="2xl" fontWeight="bold" letterSpacing="tight">{title}</Heading>
      {description && (
        <Text color="text.muted" fontSize="md">{description}</Text>
      )}
    </VStack>
    <Flex gap={3} align="center" wrap="wrap">
      {actions}
    </Flex>
  </Flex>
)

export default PageHeader
